import * as React from 'react';
import { useSelector } from 'react-redux';

import { NEWBUILDING_BROCHURE_KEY } from 'shared/constants/newbuildingBrochure';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectBrochure } from 'shared/selectors/newbuilding';

import { NewbuildingBrochure } from './components/NewbuildingBrochure';
import { trackClick } from './tracking';

export const NewbuildingBrochureContainer = () => {
  const brochure = useSelector(selectBrochure);
  const { config } = useApplicationContext();
  const isNewbuildingBrochureEnabled = config.get<boolean>(NEWBUILDING_BROCHURE_KEY);

  if (!isNewbuildingBrochureEnabled) {
    return null;
  }

  if (brochure) {
    return <NewbuildingBrochure onClick={() => trackClick()} url={brochure} />;
  }

  return null;
};
